// extracted by mini-css-extract-plugin
export default {"back-button":"styles_back-button__wvb3V"};